import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-background px-5 py-16 sm:py-20" data-id="element-103" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-xl text-center" data-id="element-104" data-mp="1o5q2iivokc11">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-subtle text-secondary" data-id="element-105" data-mp="223ob17nble8m">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-106" data-mp="1x5mtws9gfozs" />
        </span>
        <h2 className="mt-6 font-display text-xl font-black uppercase tracking-wide text-foreground sm:text-2xl" data-id="element-107" data-mp="19dz8gpuyp64w">
          La nostra garanzia «Zero Rischi»
        </h2>
        <div className="mx-auto mt-4 max-w-md space-y-3 text-sm leading-relaxed text-foreground/60" data-id="element-108" data-mp="1j4k9sl20sori">
          <p data-id="element-109" data-mp="1ee3uswijwv31">
            Prova Matematica Pronta per 7 giorni. Usalo in classe, stampa le
            schede, proietta le attività e prova il sistema con i tuoi studenti.
          </p>
          <p data-id="element-110" data-mp="qlwu5l5sm1xt">
            Se non ti fa risparmiare ore di preparazione e non rende le tue
            lezioni più semplici da organizzare, scrivici: ti rimborseremo ogni
            centesimo.
          </p>
          <p data-id="element-111" data-mp="tymhc6nprky6">E potrai tenere i 5 Bonus come regalo.</p>
        </div>
      </div>
    </section>;
}